var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.isStatic ? 'is-static': ''},[_c('div',{staticClass:"loader__item"})])}
var staticRenderFns = []

export { render, staticRenderFns }